import * as React from 'react';
import { connect } from 'react-redux';

import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { selectSpaceInfo } from '../../selectors/SpaceInfoSelectors';
import { AppState } from '../../state/AppState';
import { SpaceInfo } from '../../state/SpaceInfo';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface CollectionSpaceStateProps {
  readonly spaceInfo: SpaceInfo;
}

export interface CollectionSpaceOwnProps extends ReactDirectiveProps {
  readonly urls: SpacesSiteUrls;
  readonly reloadSpace: () => void;
  readonly telemetry: Telemetry;
}

export type CollectionSpaceProps = CollectionSpaceStateProps & CollectionSpaceOwnProps;

export class CollectionSpace extends React.PureComponent<CollectionSpaceProps> {
  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <div className={ SpaceContainerStyles.MastheadArea }>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>{this.props.spaceInfo.item.name}</div>
          </div>
        </div>
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={['list', 'thumbnail']}
            telemetry={this.props.telemetry}
            toolbarProps= {{
              supportFilterPanel: false,
              toolbarVisibility: 'enabled'
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<CollectionSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
});

export const ConnectedCollectionSpace = connect(mapStateToProps)(CollectionSpace);
